<template>
  <div v-loading="loading || ipReportDataLoading" element-loading-spinner="atom-audit-loader" style="min-height: 250px;">
    <by-code-calculations-help>
      <el-dropdown trigger="click" @command="
          command => {
            this.$emit('handleTableCommands', { command: command, ref: 'dxTable', csvName: 'dx_table', headers: [], excludeHeaders: ['Details'] })
          }
        ">
        <span class="el-dropdown-link">
          <i title="table actions" class="mdi mdi-dots-horizontal" style="font-size: 20px; cursor: pointer;"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="download">Download</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </by-code-calculations-help>

    <el-table id="dxTable" class="tableNoWrap" ref="dxTable" :data="tableData" empty-text="No Dx Data Available" max-height="425" stripe :summary-method="getSummaries"
      :cell-class-name="cellClasses" show-summary row-key="code">
      <el-table-column prop="code" label="Code" width="100" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" min-width="220" sortable>
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Occurrences" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details"></div>
        </template>
      </el-table-column>
      <el-table-column prop="dxNoRec" label="No Changes" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.dxNoRec, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="dxDeletions" label="Deletions" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.dxDeletions, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="revisedFromCount" label="Revised From" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.revisedFromCount, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`"></div>
        </template>
      </el-table-column>
      <el-table-column prop="dxAdditions" label="Additions" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.dxAdditions, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="revisedToCount" label="Revised To" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.revisedToCount, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="percentOfMissedOpportunities" label="% of All Missed Opportunities" sortable>
        <template slot-scope="scope">
          {{ formatPercentage(scope.row.percentOfMissedOpportunities) }}
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`"></div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" :sortable="true" :sort-method="boolSortComparer('isAHacCode')">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
        </template>
      </el-table-column>
      <el-table-column label="Details" width="120" prop="details" v-if="!hideDetails">
        <template slot-scope="scope">
          <el-button @click.native.prevent="updateAcctList(scope.row)" plain round size="mini" icon="mdi mdi-details" title="Records Included" circle> </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="dialogVisible" center destroy-on-close width="75%">
      <accountList :header="detailsHeader" v-if="dialogVisible" :drgTableIds="subDrgTableIds"></accountList>
    </el-dialog>

    <!-- <el-dialog :visible.sync="summaryDialogVisible" center destroy-on-close>
      <IPSummary v-if="summaryDialogVisible" :item="summaryRow"></IPSummary>
    </el-dialog> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'
  import accountList from './accoutList'
  import ByCodeCalculationsHelp from './components/ByCodeCalculationsHelp'

  export default {
    name: 'IP_DxSummary',
    mixins: [hiaFilters, money, dashboardHelper],
    props: ['drgTableIds', 'hideDetails', 'hcc'],
    components: {
      accountList,
      ByCodeCalculationsHelp
    },
    data: function () {
      return {
        tableData: [],
        filterCriteria: '',
        loading: false,
        dialogVisible: false,
        summaryDialogVisible: false,
        subDrgTableIds: null,
        summaryRow: {},
        detailsHeader: ''
      }
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          let url = `${this.baseApiUrl}/reports/dashboard/ipDx`
          if (this.hcc) {
            url = `${url}?hcc=${this.hcc.hcc}&hccVersion=${this.hcc.hccVersion}`
          }
          const response = await axios.post(url, payload)
          this.tableData = response.data.data
          this.attachMissedOpportunityPct(this.tableData, 'dxAdditions', 'revisedToCount')
        } catch (err) {
          this.tableData = []
        } finally {
          this.$nextTick(() => {
            this.$refs.dxTable.doLayout()
            this.loading = false
          })
        }
      },
      updateAcctList(row) {
        this.detailsHeader = row.code
        this.subDrgTableIds = row.accountNumbers
        this.dialogVisible = !this.dialogVisible
      },
      getSummaries(param) {
        return this.getSummary(param)
      },
      convertHccs(delimited) {
        if (delimited) {
          const retArray = delimited.split('-')
          return retArray
        } else {
          return []
        }
      },
      cellClasses({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'code' || column.property === 'description' || column.property === 'codeDesc') {
          return 'textAlignLeft'
        }
        if (column.property === 'details') {
          return 'textAlignCenter'
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('reports/', ['ipReportDataLoading'])
    },
    mounted: async function () {
      await this.getData()
    },
    activated: async function () {
      await this.getData()
    },
    watch: {
      drgTableIds: async function () {
        await this.getData()
      }
    }
  }
</script>
